/**
 * Reports (docs/05 §5, FR-REP-1..3): the shared metrics over a period, for an organization, a branch or a
 * circle, from real data only. A metric with nothing to measure is null (shown as «لا بيانات»), never 0.
 */
import { z } from "zod";
const date = z.iso.date();
export const ReportQuery = z.object({
    organizationId: z.uuid(),
    scopeType: z.enum(["organization", "branch", "circle"]),
    scopeId: z.uuid().optional(),
    from: date,
    to: date,
});
/** The counts behind the metrics: rates are ratios of sums, so groups add up. */
export const MetricCounts = z.object({
    students: z.number(),
    scheduledDays: z.number(),
    presentDays: z.number(),
    dueItems: z.number(),
    passedItems: z.number(),
    dueReviews: z.number(),
    passedReviews: z.number(),
    memorizedAyahs: z.number(),
    memorizedPages: z.number(),
    sessionsEnded: z.number(),
    sessionsLost: z.number(),
    struggling: z.number(),
});
export const Metrics = z.object({
    attendanceRate: z.number().nullable(),
    planCompletion: z.number().nullable(),
    reviewCompletion: z.number().nullable(),
    sessionSuccessRate: z.number().nullable(),
    memorizedAyahs: z.number(),
    memorizedPages: z.number(),
    strugglingStudents: z.number(),
});
export const ReportRow = z.object({
    id: z.uuid(),
    name: z.string(),
    counts: MetricCounts,
    metrics: Metrics,
});
export const ReportResponse = z.object({
    scope: z.object({ type: z.enum(["organization", "branch", "circle"]), id: z.uuid(), name: z.string() }),
    from: z.string(),
    to: z.string(),
    /** The definitions are provisional until the owner approves them (docs/05 §5). */
    definitionsApproved: z.boolean(),
    total: ReportRow.omit({ id: true }),
    /** Branches of an organization, circles of a branch, students of a circle. */
    rowKind: z.enum(["branch", "circle", "student"]),
    rows: z.array(ReportRow),
});
//# sourceMappingURL=reports.js.map